import {Component, Input} from '@angular/core';

@Component({
  selector: 'yo-icon-produitfab',
  template: `<ng-container>
    <i *ngIf="fabrique" class="fas fa-utensils yoni-color space"  pTooltip="PLAT"  [showDelay]="showDelayMs"></i>
    <i *ngIf="!fabrique" class="fas fa-apple-alt new-color space"  pTooltip="DENRÉE" [showDelay]="showDelayMs"></i>
            </ng-container>`,
  styleUrls: ['./icon-produitfab.component.scss']
})
export class IconproduitFabriqueComponent {

  @Input() fabrique: boolean;
  @Input() yoDelayMsTooltip : number;

  showDelayMs:number=1500;

  constructor() {
  }

  isProduitFabrique(): boolean {

    if (this.fabrique) {
      return true;
    } else {
      return false;
    }
  }


}
